<div class="container-xl mt-5">
    <mat-tab-group animationDuration="0ms" (selectedTabChange)="tabActive($event)">
        <mat-tab id="id-informacion" label="Información">
            <div class="content mt-5">
                <div class="row">
                    <div class="col-12 col-sm-4 col-md-3 col-lg-3">
                        <div class="card bj-white">
                            <div class="d-flex justify-content-center mt-1 mb-1">
                                <img src="../../../../assets/img/bj-home/icono-tesis-color.svg" class="card-img-top" style="width: 8rem;">
                            </div>
                            <div class="card-body border">
                                <h5 class="card-title">Tesis</h5>
                                <p class="card-text">La información fue sistematizada por la Dirección General de Compilación y Sistematización de Tesis y publicada en esta plataforma por la Unidad General de Administración del Conocimiento Jurídico.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-8 col-md-9 col-lg-9">
                        <div class="card bj-white">
                            <div class="card-body">
                                <h5 class="card-title">Tesis</h5>
                                <p class="card-text">La tesis hace referencia al criterio jurídico para resolver un caso concreto. La tesis debe ser redactada con estructura de una regla, compuesta por un supuesto de hecho que describa las circunstancias fácticas que constituyen el campo de aplicación de la regla y una consecuencia jurídica donde se establezca la solución normativa. Las cuestiones de hecho y de derecho que no son necesarias para justificar la decisión, en ningún caso deberán incluirse en la tesis. Esta definición es conforme al</p>
                                <br>
                                <div class="content">
                                    <h5 class="card-title">Descripción de los datos</h5>
                                    <table class="table table-striped border border-2">
                                        <tbody>
                                            <tr>
                                                <th scope="row">Registro Digital</th>
                                                <td>
                                                    Conjunto de números que identifican en particular a cada una de las tesis en el SJF, Apéndices e Informes. En único y permanente. Número aleatorio incremental: 5ª - 9ª época 6 dígitos, 10ª época 7 dígitos. (Ej.191000)
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Época</th>
                                                <td>
                                                    Periodo en que fue publicada la tesis en el Semanario Judicial de la Federación y su Gaceta, que reflejan cambios en la manera de integrar jurisprudencia. Quinta Época a Décima Época.
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Instancia</th>
                                                <td>
                                                    Órgano jurisdiccional que en razón de su jerarquía resuelve asuntos de su competencia. (Suprema Corte de Justicia de la Nación, Plenos de Circuito y Tribunales Colegiados de Circuito).
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Órgano Jurisdiccional</th>
                                                <td>
                                                    Denominación del Tribunal que emitió el criterio.
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Fuente</th>
                                                <td>
                                                    Medio oficial de difusión Semanario Judicial de la Federación.
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Materia</th>
                                                <td>
                                                    Clasificación que atiende a la naturaleza del asunto o figura jurídica (tema contemplado en la ley) analizada en la tesis.
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Tipo de Tesis</th>
                                                <td>
                                                    Aislada (criterio orientador) y jurisprudencia (criterio obligatorio).
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Número de identificación</th>
                                                <td>
                                                    Número de identificación de la tesis, ejemplo: Tesis: 1a./J. 8/2020 (10a.).
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Localización Ejemplar del SJF</th>
                                                <td>
                                                    Indica datos de publicación en el medio oficial de difusión que se integra por: el número del libro, tomo, volumen o número de publicación en la Gaceta o Semanario Judicial de la Federación, atendiendo a la Época de publicación.
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Título</th>
                                                <td>
                                                    El título es la mención del concepto, figura o institución jurídica que constituye la materia principal de las tesis. A través del título deberá identificarse el tema principal de que trata la tesis y servirá para la integración de tesauros e índices conceptuales, que permitan la fácil localización de los criterios interpretativos en los sistemas de cómputo o sistemas de consulta a cargo de la Dirección General. A partir de diciembre de 2013. Se coloca antes del subtítulo y se separa por un punto y seguido.
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Subtítulo</th>
                                                <td>
                                                    El subtítulo es el enunciado gramatical que identifica sintéticamente al criterio interpretativo plasmado en la tesis.
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Texto</th>
                                                <td>
                                                    Consideraciones interpretativas mediante las cuales el órgano jurisdiccional haya establecido el criterio, derivan en su integridad de la parte considerativa fundamental de la resolución correspondiente. Tratándose de jurisprudencia por reiteración, el criterio de interpretación debe contenerse en las consideraciones que se realicen en las cinco ejecutorias que la constituyan, sólo un criterio interpretativo relevante y novedoso. Se coloca después del título y subtítulo o rubro, según sea el caso, y antes del precedente.
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab id="id-grafica" label="Gráficas y Estadísticas">
            <div class="content mt-5">
                @if(load) {
                    <div class="d-flex justify-content-center mb-2">
                        <label for="filtroPorAño" class="">Filtro por año:</label>
                        <select id="startYear"
                            class="form-select form-select-sm select-size ms-2"
                            aria-label=".form-select-sm"
                            (change)="onChangeStart($event)">
                            @for (year of years; track $index) {
                                <option [selected]="currentStartYear === year" [value]="year">{{year}}</option>
                            }
                        </select>
                        <select id="endYear"
                            class="form-select form-select-sm select-size ms-2"
                            aria-label=".form-select-sm"
                            (change)="onChangeEnd($event)">
                            @for (year of years; track $index) {
                                <option [selected]="currentEndYear === year" [value]="year">{{year}}</option>
                            }
                        </select>
                    </div>
                    <div class="d-flex justify-content-end mb-2 me-2">
                        <button type="button" class="btn btn-outline-secondary me-2" (click)="loadTablePrincipal();typeGraph = 1">Puntos</button>
                        <button type="button" class="btn btn-outline-secondary ms-2" (click)="loadBarPrincipal();typeGraph = 2">Barras</button>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <figure class="highcharts-figure">
                                <div id="container"></div>
                            </figure>
                        </div>
                    </div>
                    @if (tables && tables.length > 0) {
                        @for (table of tables; track table.id) {
                            <div class="row mt-5">
                                <div class="col-12">
                                    <h4 class="card-title text-center mt-2 mb-3">{{table.data.title}}</h4>
                                    <div class="d-flex justify-content-end mb-2 me-2">
                                        <button type="button" class="btn btn-outline-secondary me-2" (click)="onClickType(1, table.id)">Tabla</button>
                                        <button type="button" class="btn btn-outline-secondary ms-2" (click)="onClickType(0, table.id)">Gráfica</button>
                                    </div>
                                    <div class="d-flex justify-content-center">
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input"
                                                type="radio"
                                                name="epocaRadio{{table.id}}"
                                                id="epocaPreviousEpoca{{table.id}}"
                                                value="10"
                                                [checked]="table.epoca === 10"
                                                (change)="onChangeEpoca(10, table.id)">
                                            <label class="form-check-label" for="epocaPreviousEpoca{{table.id}}">Época  10</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input"
                                                type="radio"
                                                name="epocaRadio{{table.id}}"
                                                id="radioLastEpoca{{table.id}}"
                                                value="11"
                                                [checked]="table.epoca === 11"
                                                (change)="onChangeEpoca(11, table.id)">
                                            <label class="form-check-label" for="radioLastEpoca{{table.id}}">Época  11</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            @if (table.typeTable === 1) {
                                <div class="row">
                                    <div class="col-12">
                                        <table class="table table-striped border border-2">
                                            @if (table.data && table.data.header) {
                                                <thead>
                                                    <tr>
                                                        @for (head of table.data.header; track $index) {
                                                            <th class="text-center font-scjn-16" scope="col">{{head.header}}</th>
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    @for (th of table.data.tabla; track $index) {
                                                        <tr>
                                                            @for (item of table.data.header; track item;let id = $index;) {
                                                                <td class="text-center">{{th["value" + (id + 1)]}}</td>
                                                            }
                                                        </tr>
                                                    }
                                                </tbody>
                                            }
                                        </table>
                                    </div>
                                </div>
                            }
                            @else if (table.typeTable === 0) {
                                <div class="row">
                                    <div class="col-12">
                                        <figure class="highcharts-figure">
                                            <div id="container{{table.id}}"></div>
                                        </figure>
                                    </div>
                                </div>
                            }
                        }
                    }
                }
            </div>
        </mat-tab>
    </mat-tab-group>
</div>